var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.className,attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"type":"text"},domProps:{"value":_vm.value},on:{"keydown":function (e) { return _vm.validateNumber(e); },"input":_vm.inputEvent}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5adf423e","hasScoped":false,"optionsId":"11","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/input-number.vue
// module id = Z+Ig
// module chunks = 0